/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  ReplyListApiV1CollaborationAppReplyGetQueryResponse,
  ReplyListApiV1CollaborationAppReplyGetQueryParams,
  ReplyListApiV1CollaborationAppReplyGetHeaderParams,
  ReplyListApiV1CollaborationAppReplyGet422,
} from '../../types/ReplyListApiV1CollaborationAppReplyGet.ts'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const replyListApiV1CollaborationAppReplyGetQueryKey = (params?: ReplyListApiV1CollaborationAppReplyGetQueryParams) =>
  [{ url: '/api/v1/collaboration_app/reply' }, ...(params ? [params] : [])] as const

export type ReplyListApiV1CollaborationAppReplyGetQueryKey = ReturnType<typeof replyListApiV1CollaborationAppReplyGetQueryKey>

/**
 * @summary Reply List
 * {@link /api/v1/collaboration_app/reply}
 */
export async function replyListApiV1CollaborationAppReplyGet(
  params?: ReplyListApiV1CollaborationAppReplyGetQueryParams,
  headers?: ReplyListApiV1CollaborationAppReplyGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<ReplyListApiV1CollaborationAppReplyGetQueryResponse, ResponseErrorConfig<ReplyListApiV1CollaborationAppReplyGet422>, unknown>({
    method: 'GET',
    url: `/api/v1/collaboration_app/reply`,
    params,
    ...requestConfig,
    headers: { ...headers, ...requestConfig.headers },
  })
  return res.data
}

export function replyListApiV1CollaborationAppReplyGetQueryOptions(
  params?: ReplyListApiV1CollaborationAppReplyGetQueryParams,
  headers?: ReplyListApiV1CollaborationAppReplyGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = replyListApiV1CollaborationAppReplyGetQueryKey(params)
  return queryOptions<
    ReplyListApiV1CollaborationAppReplyGetQueryResponse,
    ResponseErrorConfig<ReplyListApiV1CollaborationAppReplyGet422>,
    ReplyListApiV1CollaborationAppReplyGetQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return replyListApiV1CollaborationAppReplyGet(params, headers, config)
    },
  })
}

/**
 * @summary Reply List
 * {@link /api/v1/collaboration_app/reply}
 */
export function useReplyListApiV1CollaborationAppReplyGet<
  TData = ReplyListApiV1CollaborationAppReplyGetQueryResponse,
  TQueryData = ReplyListApiV1CollaborationAppReplyGetQueryResponse,
  TQueryKey extends QueryKey = ReplyListApiV1CollaborationAppReplyGetQueryKey,
>(
  params?: ReplyListApiV1CollaborationAppReplyGetQueryParams,
  headers?: ReplyListApiV1CollaborationAppReplyGetHeaderParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ReplyListApiV1CollaborationAppReplyGetQueryResponse,
        ResponseErrorConfig<ReplyListApiV1CollaborationAppReplyGet422>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? replyListApiV1CollaborationAppReplyGetQueryKey(params)

  const query = useQuery(
    {
      ...replyListApiV1CollaborationAppReplyGetQueryOptions(params, headers, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<ReplyListApiV1CollaborationAppReplyGet422>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}